import { useState } from 'react'

interface ErrorMessageProps {
  message: string
  maxLength?: number
  className?: string
  onDismiss?: () => void
}

export default function ErrorMessage({
  message,
  maxLength = 100,
  className = '',
  onDismiss,
}: ErrorMessageProps) {
  const [showFull, setShowFull] = useState(false)

  const isTruncated = message.length > maxLength
  const displayMessage = isTruncated && !showFull
    ? message.slice(0, maxLength) + '...'
    : message

  return (
    <div
      className={`relative bg-red-50 border border-red-200 rounded-md p-3 ${className}`}
    >
      <div className="flex items-start gap-2">
        <svg
          className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-red-700 break-words">
            {displayMessage}
          </p>
          {isTruncated && (
            <button
              type="button"
              onClick={() => setShowFull(!showFull)}
              className="text-xs text-red-600 hover:text-red-800 underline mt-1"
            >
              {showFull ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="flex-shrink-0 text-red-400 hover:text-red-600"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}
